<script module lang="ts">
  import { ModalState } from '~/lib/nav.svelte';
  export const reportWordModal = new ModalState('report-word');
</script>

<script lang="ts">
  import QuestionMark from '../icons/QuestionMark.svelte';
  import Close from '~icons/mdi/close';
  import Flag from '~icons/mdi/flag';
  import ActionButton from '../components/ActionButton.svelte';
  import Modal from '../components/Modal.svelte';
  import Spinner from '~/components/Spinner.svelte';
  import { reportWordMutation } from '~/lib/mutations.svelte';
  import { onDestroy } from 'svelte';
  import HashIcon from '~icons/feather/hash';
  import { toast } from 'svelte-sonner';

  const { word }: { word: string } = $props();
  const reportWord = reportWordMutation();

  const handleReport = async (reason: 'insensitive' | 'obscure') => {
    if (word) {
      await reportWord.mutateAsync({ word, reason });
      handleClose();
      toast.success('Reported')
    }
  };

  const handleOpen = () => {
    reportWordModal.push();
  };

  const handleClose = () => {
    reportWordModal.pop();
  };

  onDestroy(() => {
    reportWord.reset();
  });
</script>

<div class:reported={reportWord.isSuccess}>
  <ActionButton onClick={handleOpen} disabled={!reportWord.isIdle}>
    <Flag />
    Report word
  </ActionButton>
</div>
<Modal open={reportWordModal.open} onClose={handleClose} index={5}>
  {#snippet title()}
    Report {word}
  {/snippet}
  {#snippet content()}
    <div class="controls">
      <p>
        Reported words will be manually reviewed to decide whether to remove
        them from the dictionary
      </p>
      {#if reportWord.isPending}
        <Spinner />
      {:else}
        <ActionButton class="large" onClick={() => handleReport('insensitive')}>
          <HashIcon />
          Profane
        </ActionButton>
        <ActionButton class="large" onClick={() => handleReport('obscure')}>
          <QuestionMark />
          Obscure
        </ActionButton>
      {/if}
    </div>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      <Close />
      Close
    </ActionButton>
  {/snippet}
</Modal>

<style lang="scss">
  @use '../theme/theme';
  .controls {
    display: grid;
    align-items: center;
    justify-items: center;
    gap: 0.5em;
  }
  .reported {
    :global(.action) {
      @include theme.pulse-animation(theme.$tile-blue-dark);
    }
  }
</style>
